import { HTTP } from "@/api";

export default {
  getUserList({ commit, state }) {
    commit("isLoading", {
      key: "users",
      status: true
    });
    const search = state.users.search;
    const limit = state.users.limit;
    const offset = (state.users.page - 1) * limit;
    const url = `/users?limit=${limit}&offset=${offset}&search=${search}`;
    return HTTP.get(url).then(res => {
      const data = res.data;
      if (data.success) {
        commit("users", data.result.users);
        commit("usersCounter", data.result.counter);
      }
      return data.success;
    });
  },
  createUser({ commit }, data) {
    return HTTP.post(`/users`, data).then(res => {
      const data = res.data;
      if (data.success) {
        commit("user", data.result);
      }
      return data.success;
    });
  },
  updateUser({ commit }, data) {
    return HTTP.put(`/users`, data).then(res => {
      const data = res.data;
      if (data.success) {
        commit("user", data.result);
      }
      return data.success;
    });
  },
  removeUser({ commit, state }, id) {
    return HTTP.delete(`/users/${id}`).then(res => {
      const data = res.data;
      if (data.success) {
        const users = state.users.list.filter(({ _id }) => _id !== id);
        commit("users", users);
      }
      if (data.error) throw new Error(data.error);
      return data.success;
    });
  },
  addUserSubscription({ commit }, { userId, subscriptionId }) {
    return HTTP.post(`/users/subscription`, { userId, subscriptionId }).then(
      res => {
        const data = res.data;
        if (data.success) commit("user", data.result);
        if (data.error) throw new Error(data.error);
        return data.success;
      }
    );
  },
  deleteUserSubscription({ commit }, subId) {
    return HTTP.delete(`/users/subscription/${subId}`).then(res => {
      const data = res.data;
      if (data.success) commit("user", data.result);
      if (data.error) throw new Error(data.error);
      return data.success;
    });
  },
  removeDevice({ commit, state }, {userId, id}) {
    const url = `/users/device?userId=${userId}&id=${id}`;
    return HTTP.delete(url).then(res => {
      const data = res.data;
      if (data.success) {
        const users = state.users.list.map( user => user._id == userId ? {...user, devices: data.devices} : user);
        commit("users", users);
      }
      if (data.error) throw new Error(data.error);
      return data.success;
    });
  }
};
